import { Avatar, AvatarGroup, Box, InputLabel, Stack, Tooltip, Typography, useTheme } from '@mui/material'
import { CommentData, User } from 'types'
import { formatDateTime } from 'utils/formatDayjsDateTime'

const ReadByIcon = ({ note, users }: { note: CommentData; users: User[] }) => {
  const _theme = useTheme()
  return (
    <Tooltip
      title={
        <Stack>
          <InputLabel sx={{ fontSize: 11, textAlign: 'left' }}>Viewed by:</InputLabel>
          {note.readBy.map((read: any) => {
            const readByUser = users?.find(u => u?.user_uuid === read?.user_uuid)
            return (
              <Box key={`${note?.SK}-${readByUser?.user_uuid}`} className="box-row">
                <Avatar alt={readByUser.user_uuid} src={readByUser.image_512} sx={{ width: 24, height: 24, ml: 0.5 }} />
                <Typography sx={{ color: 'text.secondary', fontSize: 12 }}>{formatDateTime(read.readAt)}</Typography>
              </Box>
            )
          })}
        </Stack>
      }
    >
      <div>
        <AvatarGroup max={4}>
          {note.readBy.map((read: any) => {
            const readByUser = users?.find(u => u?.user_uuid === read?.user_uuid) ?? null
            return (
              <Avatar
                key={`${note?.SK}-${readByUser?.user_uuid}`}
                alt={readByUser.user_uuid}
                src={readByUser.image_512}
                sx={{ width: 16, height: 16, ml: 0.5 }}
              />
            )
          })}
        </AvatarGroup>
        {/* <VisibilityIcon fontSize="small" sx={{ bgcolor: 'transparent', color: 'text.' }} /> */}
      </div>
    </Tooltip>
  )
}
export default ReadByIcon
